import { CheckoutErrorStatus } from '@checkout/util-models';
import { retrieveErrorStatusCode } from '@domgen/dgx-fe-common';
import { ErrorRoutes } from '@error/util-models';

export function checkoutErrorMessage(error: Error): string | undefined {
  const errorStatusCode: string | undefined = retrieveErrorStatusCode(error);

  switch (errorStatusCode) {
    case CheckoutErrorStatus.CommericalAddress:
      return 'Sorry, the address you provided is listed as a commercial address, please check your information and try again.';
    case CheckoutErrorStatus.ExpiredOffer:
      return 'Sorry, that offer has expired, please restart the journey.';
    case CheckoutErrorStatus.ExpiredRenewal:
      return 'Sorry, that renewal has expired, please restart the journey.';
    case CheckoutErrorStatus.Ineligible:
      return;
    case CheckoutErrorStatus.InvalidCustomer:
      return 'Sorry, this offer is not available to you, please restart the journey.';
    case CheckoutErrorStatus.InvalidCustomerData:
      return 'Sorry, this offer is not available to you, please restart the journey.';
    case CheckoutErrorStatus.InvalidOfferReference:
      return "Sorry, we couldn't find that offer, please restart the journey.";
    case CheckoutErrorStatus.InvalidOfferRenewalStatus:
      return 'Sorry, that offer has expired, please restart the journey.';
    case CheckoutErrorStatus.InvalidPayment:
    case CheckoutErrorStatus.InvalidPaymentData:
      return 'Sorry, your payment information is not valid, please check your information and try again.';
    case CheckoutErrorStatus.NoOffers:
      return "Sorry, we couldn't find the quote you are purchasing, please restart the journey.";
    case CheckoutErrorStatus.NoPlanSchemeFound:
      return "Sorry, we couldn't find the plan you are purchasing, please restart the journey.";
    case CheckoutErrorStatus.PlanLapsed:
      return 'Sorry, that plan has lapsed, please restart the journey.';
    case CheckoutErrorStatus.PlanSkipped:
      return 'Sorry, that plan has been skipped, please restart the journey.';
    case CheckoutErrorStatus.PostCodeMatch:
      return 'Sorry, this offer is not available to you, please restart the journey.';
    case CheckoutErrorStatus.SalesforceInternalService:
      return 'Sorry, this offer is not available to you, please restart the journey.';
    default:
      return 'Sorry, something went wrong, please restart the journey.';
  }
}

export function isCheckoutErrorStatus(
  checkoutErrorStatusCode: CheckoutErrorStatus,
  error: Error
): boolean {
  const errorStatusCode: string | undefined = retrieveErrorStatusCode(error);

  return errorStatusCode === checkoutErrorStatusCode;
}

export function getRedirectPage(error: Error): string {
  const errorStatusCode: string | undefined = retrieveErrorStatusCode(error);
  switch (errorStatusCode) {
    case CheckoutErrorStatus.WeightLimitExceeded:
      return ErrorRoutes.Sorry;
    default:
      return ErrorRoutes.Generic;
  }
}

export function isCriticalCheckoutError(error: Error): boolean {
  const errorStatusCode: string | undefined = retrieveErrorStatusCode(error);

  switch (errorStatusCode) {
    case CheckoutErrorStatus.CommericalAddress:
    case CheckoutErrorStatus.Ineligible:
    case CheckoutErrorStatus.InvalidPayment:
    case CheckoutErrorStatus.InvalidPaymentData:
    case CheckoutErrorStatus.InvalidCustomerData:
    case CheckoutErrorStatus.SalesforceInternalService:
      return false;
    case CheckoutErrorStatus.ExpiredOffer:
    case CheckoutErrorStatus.ExpiredRenewal:
    case CheckoutErrorStatus.InvalidCustomer:
    case CheckoutErrorStatus.InvalidOfferReference:
    case CheckoutErrorStatus.InvalidOfferRenewalStatus:
    case CheckoutErrorStatus.NoOffers:
    case CheckoutErrorStatus.NoPlanSchemeFound:
    case CheckoutErrorStatus.PlanLapsed:
    case CheckoutErrorStatus.PlanSkipped:
    case CheckoutErrorStatus.PostCodeMatch:
    case CheckoutErrorStatus.WeightLimitExceeded:
    default:
      return true;
  }
}
